<template>
    <!-- Panel admin de Reservas (/reservations). Diseño de Mi cuenta (bkCuenta.css
         + cuentaMenu.css): lateral con título, cifras y el resumen del modelo 4 %;
         a la derecha buscador, filtros y la lista. Al abrir una reserva, un panel
         con el reparto del cobro que calcula la API (`desglose`, ver
         ReservaDesgloseService) y las acciones de siempre. Demo aprobada:
         Desktop/nuevo-reserva. -->
    <div class="ra-page">
        <div class="bk ra">
            <aside class="bk-side ra-side">
                <router-link :to="{ name: 'admin' }" class="ra-back">
                    <span aria-hidden="true" v-html="IC.back"></span>{{ $t('admin_reservas.back') }}
                </router-link>
                <h1 class="bk-title">{{ $t('admin_reservas.title_a') }} <span class="bk-grad">{{ $t('admin_reservas.title_b') }}</span></h1>
                <p class="bk-subtitle">{{ $t('admin_reservas.sub') }}</p>

                <div class="ra-stats" aria-live="polite">
                    <div class="bk-stat"><p class="bk-stat-n">{{ resumen.total }}</p><p class="bk-stat-l">{{ $t('admin_reservas.stat.total') }}</p></div>
                    <div class="bk-stat bk-stat--wait"><p class="bk-stat-n">{{ resumen.porResponder }}</p><p class="bk-stat-l">{{ $t('admin_reservas.stat.to_answer') }}</p></div>
                    <div class="bk-stat ra-stat--pay"><p class="bk-stat-n">{{ resumen.sinPagar }}</p><p class="bk-stat-l">{{ $t('admin_reservas.stat.to_pay') }}</p></div>
                    <div class="bk-stat bk-stat--ok"><p class="bk-stat-n">{{ resumen.pagadas }}</p><p class="bk-stat-l">{{ $t('admin_reservas.stat.paid') }}</p></div>
                </div>
            </aside>

            <section :class="['ra-main', { 'is-cargando': cargando && filas.length }]" :aria-busy="String(cargando)" aria-labelledby="ra-list-title">
                <div class="ra-toolbar">
                    <label class="ra-search">
                        <span aria-hidden="true" v-html="IC.search"></span>
                        <span class="bk-sr-only">{{ $t('admin_reservas.search_label') }}</span>
                        <input v-model="busqueda" type="search" autocomplete="off" :placeholder="$t('admin_reservas.search_ph')" />
                    </label>
                    <div class="ra-seg" role="group" :aria-label="$t('admin_reservas.f.status')">
                        <button
                            v-for="e in ESTADOS"
                            :key="e"
                            type="button"
                            :class="{ 'is-on': f.estado === e }"
                            :aria-pressed="String(f.estado === e)"
                            @click="cambiar('estado', e)"
                        >{{ $t(`admin_reservas.f.${e}`) }}</button>
                    </div>
                    <!-- Filtros: misma tarjeta para todos (etiqueta arriba, valor abajo);
                         la que está aplicada se marca en naranja. -->
                    <div class="ra-fgrid">
                        <label v-for="s in SELECTS" :key="s.k" :class="['ra-f', { 'is-on': f[s.k] !== 'all' }]">
                            <span class="ra-f-k">{{ $t(`admin_reservas.f.${s.t}`) }}</span>
                            <select class="ra-f-v" :value="f[s.k]" @change="cambiar(s.k, $event.target.value)">
                                <option v-for="o in s.o" :key="o.v" :value="o.v">{{ $t(`admin_reservas.f.${o.t}`) }}</option>
                            </select>
                        </label>
                        <!-- Fecha en que se hizo la reserva (días enteros). -->
                        <div :class="['ra-f', 'ra-f--fecha', { 'is-on': !!(f.desde || f.hasta) }]" role="group" :aria-label="$t('admin_reservas.f.date')">
                            <span class="ra-f-k">{{ $t('admin_reservas.f.date') }}</span>
                            <div class="ra-f-range">
                                <input type="date" class="ra-f-v" :value="f.desde" :max="f.hasta || hoy" :aria-label="$t('admin_reservas.f.date_from')" @change="cambiar('desde', $event.target.value)" />
                                <span class="ra-f-arrow" aria-hidden="true">→</span>
                                <input type="date" class="ra-f-v" :value="f.hasta" :min="f.desde || null" :max="hoy" :aria-label="$t('admin_reservas.f.date_to')" @change="cambiar('hasta', $event.target.value)" />
                            </div>
                        </div>
                    </div>
                    <div v-if="activos.length" class="ra-chips">
                        <button v-for="c in activos" :key="c.k" type="button" class="ra-chip-f" :aria-label="$t('admin_reservas.f.remove', { f: c.t })" @click="quitar(c.k)">
                            {{ c.t }}<span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>

                <div class="ra-head">
                    <h2 id="ra-list-title" class="ra-head-title">{{ $t('admin_reservas.list_title') }}</h2>
                    <span class="ra-head-n">{{ $tc('admin_reservas.results', datos.total || 0, { n: datos.total || 0 }) }}</span>
                    <button v-if="filtrando" type="button" class="ra-clear" @click="limpiar">{{ $t('admin_reservas.clear') }}</button>
                </div>

                <div v-if="cargando && !filas.length" class="ra-loading"><HyFLoader variant="inline" /></div>

                <div v-else-if="error" class="ra-empty" role="alert">
                    <h3>{{ $t('admin_reservas.error_title') }}</h3>
                    <p>{{ $t('admin_reservas.error_text') }}</p>
                    <button type="button" class="bk-btn bk-btn--primary" @click="cargar">{{ $t('admin_reservas.retry') }}</button>
                </div>

                <div v-else-if="!filas.length" class="ra-empty">
                    <h3>{{ $t('admin_reservas.empty_title') }}</h3>
                    <p>{{ $t('admin_reservas.empty_text') }}</p>
                    <button v-if="filtrando" type="button" class="bk-btn bk-btn--ghost" @click="limpiar">{{ $t('admin_reservas.clear') }}</button>
                </div>

                <template v-else>
                    <div class="ra-cols" aria-hidden="true">
                        <span>{{ $t('admin_reservas.cols.id') }}</span><span>{{ $t('admin_reservas.cols.place') }}</span><span>{{ $t('admin_reservas.cols.people') }}</span><span>{{ $t('admin_reservas.cols.money') }}</span>
                    </div>
                    <ul class="ra-list">
                        <li v-for="(r, i) in filas" :key="r.id" class="ra-item" :style="{ animationDelay: `${i * 0.03}s` }">
                            <button
                                type="button"
                                :class="['ra-row', `ra-row--${r.e.k}`, { 'ra-row--new': r.nueva, 'is-open': abiertaId === r.id }]"
                                :data-id="r.id"
                                :aria-label="$t('admin_reservas.row.open', { id: r.id })"
                                @click="abrir(r.id, $event.currentTarget)"
                            >
                                <span v-if="r.nueva" class="ra-new">{{ $t('admin_reservas.row.new') }}</span>
                                <span class="ra-c ra-c--id">
                                    <span class="ra-id">#{{ r.id }} <small>· {{ r.creadaCorta }}</small></span>
                                    <span class="ra-c-tags">
                                        <span :class="['bk-badge', `bk-badge--${r.e.badge}`]">{{ $t(`admin_reservas.st.${r.e.t}`) }}</span>
                                        <span v-if="r.d" :class="['ra-model', r.d.modelo.es_comision ? 'ra-model--4' : 'ra-model--g']" :title="r.d.modelo.nombre">{{ r.d.modelo.es_comision ? '4 %' : $t('admin_reservas.row.guarantee') }}</span>
                                        <span v-if="r.raw.con_intake" class="ra-model ra-model--plain">{{ $t('admin_reservas.row.intake') }}</span>
                                    </span>
                                </span>
                                <span class="ra-c ra-c--place">
                                    <span class="ra-place">{{ r.alojamiento || '—' }}</span>
                                    <span class="ra-meta">
                                        <b>{{ r.fechas }}</b><span class="ra-dot"></span>{{ $tc('admin_reservas.row.nights', r.noches, { n: r.noches }) }}<span class="ra-dot"></span>{{ $t('admin_reservas.row.acc', { id: r.alojamientoId }) }}<template v-if="r.cupon"><span class="ra-dot"></span>{{ r.cupon.code }}</template>
                                    </span>
                                </span>
                                <span class="ra-c ra-c--who">
                                    <span class="ra-who"><span class="ra-who-k ra-who-k--h" :title="$t('admin_reservas.row.guest')">H</span><span>{{ r.huesped.nombre }}</span></span>
                                    <span class="ra-who"><span class="ra-who-k ra-who-k--a" :title="$t('admin_reservas.row.host')">A</span><span>{{ r.anfitrion.nombre }}</span></span>
                                </span>
                                <span class="ra-c ra-money">
                                    <template v-if="r.d">
                                        <span class="ra-money-n" :title="r.convertida ? dinero(r.d.total, r.moneda) : null">{{ plata(r.d.total, r.moneda) }}</span>
                                        <span class="ra-money-k">{{ $t(r.pagada ? 'admin_reservas.row.charged' : 'admin_reservas.row.to_charge') }}</span>
                                        <span v-if="r.d.modelo.es_comision" class="ra-chip">{{ tasaTxt(r.d.tasa_anfitrion) }} · {{ plata(r.d.comision_anfitrion, r.moneda) }}</span>
                                        <span v-else-if="r.d.garantia" class="ra-chip ra-chip--g">{{ $t('admin_reservas.row.guarantee') }} · {{ plata(r.d.garantia, r.moneda) }}</span>
                                    </template>
                                    <span v-if="r.pagada" class="ra-paid ra-paid--si"><span aria-hidden="true" v-html="IC.ok"></span>{{ $t('admin_reservas.row.paid_on', { d: r.pagoNum }) }}</span>
                                    <span v-else class="ra-paid ra-paid--no"><span aria-hidden="true" v-html="IC.no"></span>{{ $t('admin_reservas.row.unpaid') }}</span>
                                </span>
                                <span class="ra-go" aria-hidden="true" v-html="IC.chev"></span>
                            </button>
                        </li>
                    </ul>
                </template>

                <BkPaginacion v-if="!error && (datos.last_page || 1) > 1" :actual="datos.current_page || 1" :ultima="datos.last_page || 1" :total="datos.total" @ir="irAPagina" />
            </section>
        </div>

        <!-- ═══ Detalle ═══ -->
        <div v-if="abierta" :class="['ra-drawer', { 'is-closing': cerrando }]" :style="{ '--ra-cookies': cookiesAlto + 'px' }">
            <div class="ra-drawer-bg" @click="cerrar"></div>
            <article ref="card" class="ra-drawer-card" role="dialog" aria-modal="true" aria-labelledby="ra-d-title" tabindex="-1">
                <header class="ra-d-top">
                    <div class="ra-d-row">
                        <h2 id="ra-d-title" class="ra-d-title">
                            {{ $t('admin_reservas.d.title', { id: abierta.id }) }}
                            <small>{{ $t('admin_reservas.d.requested_on', { d: abierta.creadaNum }) }}<template v-if="abierta.nueva"> · {{ $t('admin_reservas.d.is_new') }}</template></small>
                        </h2>
                        <button type="button" class="ra-x" :aria-label="$t('admin_reservas.d.close')" @click="cerrar"><span v-html="IC.x"></span></button>
                    </div>
                    <div class="ra-d-tags">
                        <span :class="['bk-badge', `bk-badge--${abierta.e.badge}`]">{{ $t(`admin_reservas.st.${abierta.e.t}`) }}</span>
                        <span v-if="abierta.d" :class="['ra-model', abierta.d.modelo.es_comision ? 'ra-model--4' : 'ra-model--g']" :title="abierta.d.modelo.nombre">{{ abierta.d.modelo.es_comision ? '4 %' : $t('admin_reservas.row.guarantee') }}</span>
                        <button type="button" class="ra-copy" :title="$t('admin_reservas.d.copy')" @click="copiar(abierta.id)"><span aria-hidden="true" v-html="IC.copy"></span>{{ $t('admin_reservas.d.copy_id', { id: abierta.id }) }}</button>
                        <span v-if="abierta.cupon" class="ra-model ra-model--plain">{{ $t('admin_reservas.d.coupon', { code: abierta.cupon.code, p: abierta.cupon.percentage }) }}</span>
                    </div>
                    <ol class="ra-steps">
                        <li v-for="p in abierta.pasos" :key="p.k" :class="['ra-step', p.st ? `is-${p.st}` : '']">
                            <i aria-hidden="true">{{ p.st === 'done' ? '✓' : p.st === 'end' ? '✕' : '' }}</i>{{ $t(`admin_reservas.d.step.${p.k}`) }}
                        </li>
                    </ol>
                </header>

                <div class="ra-d-body">
                    <section class="ra-card">
                        <a class="ra-place-link" :href="abierta.fichaUrl" target="_blank" rel="noopener" :title="$t('admin_reservas.d.open_place')">
                            <span class="ra-place-ico" aria-hidden="true" v-html="IC.home"></span>
                            <span><b>{{ abierta.alojamiento || '—' }}</b><small>{{ abierta.direccion }}<template v-if="abierta.direccion"> · </template>{{ $t('admin_reservas.row.acc', { id: abierta.alojamientoId }) }}</small></span>
                            <span aria-hidden="true" v-html="IC.ext"></span>
                        </a>
                        <div class="ra-dates">
                            <div class="ra-date"><span class="k">{{ $t('admin_reservas.d.check_in') }}</span><span class="d">{{ abierta.ent.dia }}</span><span class="m">{{ abierta.ent.mes }}</span></div>
                            <div class="ra-nights"><span>{{ $tc('admin_reservas.row.nights', abierta.noches, { n: abierta.noches }) }}</span></div>
                            <div class="ra-date ra-date--end"><span class="k">{{ $t('admin_reservas.d.check_out') }}</span><span class="d">{{ abierta.sal.dia }}</span><span class="m">{{ abierta.sal.mes }}</span></div>
                        </div>
                        <div class="ra-facts">
                            <div class="ra-fact"><span class="k">{{ $t('admin_reservas.d.rent') }}</span><span class="v">{{ abierta.arriendo }}</span></div>
                            <div class="ra-fact"><span class="k">{{ $t('admin_reservas.d.mode') }}</span><span class="v">{{ abierta.modalidad }}</span></div>
                            <div class="ra-fact"><span class="k">{{ $t('admin_reservas.d.guests') }}</span><span class="v">{{ abierta.huespedes }}</span></div>
                        </div>
                    </section>

                    <!-- Reparto del cobro -->
                    <section v-if="reparto" class="ra-card ra-split" aria-labelledby="ra-split-t">
                        <div class="ra-split-head">
                            <span :class="['ra-model', reparto.es4 ? 'ra-model--4' : 'ra-model--g']">{{ reparto.es4 ? '4 %' : $t('admin_reservas.row.guarantee') }}</span>
                            <h3 id="ra-split-t">{{ $t('admin_reservas.split.title') }}</h3>
                            <span class="ra-split-state">{{ reparto.estado }}</span>
                            <p class="ra-split-origin">{{ reparto.modeloNombre }} · {{ $t(`admin_reservas.split.origin_${reparto.origen}`) }}</p>
                        </div>
                        <div class="ra-split-body">
                            <div>
                                <div class="ra-bar" role="img" :aria-label="$t('admin_reservas.split.bar', reparto.barPct)">
                                    <span class="b-host" :style="{ width: reparto.bar.host + '%' }"></span>
                                    <span v-if="reparto.bar.fee" class="b-hf" :style="{ width: reparto.bar.fee + '%' }"></span>
                                    <span class="b-guest" :style="{ width: reparto.bar.cargo + '%' }"></span>
                                </div>
                                <div class="ra-legend">
                                    <span><i class="l-host"></i>{{ $t('admin_reservas.split.legend_host', { m: reparto.leyenda.host }) }}</span>
                                    <span v-if="reparto.bar.fee"><i class="l-hf"></i>{{ $t('admin_reservas.split.legend_fee', { p: reparto.tasa, m: reparto.leyenda.fee }) }}</span>
                                    <span><i class="l-guest"></i>{{ $t('admin_reservas.split.legend_charge', { m: reparto.leyenda.cargo }) }}</span>
                                </div>
                            </div>

                            <div class="ra-flow">
                                <div v-for="b in reparto.cajas" :key="b.k" :class="['ra-box', `ra-box--${b.k}`]">
                                    <div class="ra-box-head">
                                        <span class="ra-box-ico" aria-hidden="true">{{ b.ico }}</span>
                                        <div><b>{{ b.titulo }}</b><small>{{ b.sub }}</small></div>
                                    </div>
                                    <ul class="ra-lines">
                                        <li v-for="(l, j) in b.lineas" :key="j" :class="['ra-line', l.cls]">
                                            <span>{{ l.label }}<small v-if="l.sub">{{ l.sub }}</small></span>
                                            <b>{{ l.val }}</b>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div v-if="reparto.convNota" class="ra-note"><span aria-hidden="true" v-html="IC.info"></span><span>{{ reparto.convNota }}</span></div>
                            <div v-if="reparto.es4" class="ra-note"><span aria-hidden="true" v-html="IC.info"></span><span>{{ $t('admin_reservas.split.note_4', { p: reparto.tasa }) }}</span></div>
                            <div v-if="reparto.control" :class="['ra-note', `ra-note--${reparto.control.k}`]"><span aria-hidden="true" v-html="reparto.control.k === 'ok' ? IC.ok : IC.warn"></span><span>{{ reparto.control.txt }}</span></div>
                        </div>
                    </section>

                    <!-- Sin desglose (API sin desplegar): los montos guardados, como antes. -->
                    <section v-else class="ra-card">
                        <p class="ra-card-k">{{ $t('admin_reservas.d.no_breakdown') }}</p>
                        <div class="ra-facts">
                            <div class="ra-fact"><span class="k">{{ $t('admin_reservas.d.amount') }}</span><span class="v">{{ plata(abierta.raw.costo, abierta.moneda) }}</span></div>
                            <div class="ra-fact"><span class="k">{{ $t('admin_reservas.d.commission') }}</span><span class="v">{{ plata(abierta.raw.comision, abierta.moneda) }}</span></div>
                            <div class="ra-fact"><span class="k">{{ $t('admin_reservas.row.guarantee') }}</span><span class="v">{{ plata(abierta.raw.garantia, abierta.moneda) }}</span></div>
                        </div>
                    </section>

                    <div class="ra-people">
                        <div class="ra-person ra-person--a">
                            <div class="ra-person-top"><span class="ra-av" aria-hidden="true">{{ abierta.anfitrion.ini }}</span><div><small>{{ $t('admin_reservas.row.host') }}</small><b>{{ abierta.anfitrion.nombre }}</b></div></div>
                            <a v-if="abierta.anfitrion.correo" class="ra-contact" :href="`mailto:${abierta.anfitrion.correo}`"><span aria-hidden="true" v-html="IC.mail"></span><span>{{ abierta.anfitrion.correo }}</span></a>
                            <a v-if="abierta.anfitrion.telefono" class="ra-contact" :href="`tel:${abierta.anfitrion.tel}`"><span aria-hidden="true" v-html="IC.tel"></span><span>{{ abierta.anfitrion.telefono }}</span></a>
                            <button v-if="abierta.anfitrion.id" type="button" class="ra-link" @click="irBackoffice(abierta.anfitrion.id)">{{ $t('admin_reservas.p.backoffice') }} <span aria-hidden="true" v-html="IC.chev"></span></button>
                        </div>
                        <div class="ra-person ra-person--h">
                            <div class="ra-person-top"><span class="ra-av" aria-hidden="true">{{ abierta.huesped.ini }}</span><div><small>{{ $t('admin_reservas.row.guest') }}</small><b>{{ abierta.huesped.nombre }}</b></div></div>
                            <a v-if="abierta.huesped.correo" class="ra-contact" :href="`mailto:${abierta.huesped.correo}`"><span aria-hidden="true" v-html="IC.mail"></span><span>{{ abierta.huesped.correo }}</span></a>
                            <a v-if="abierta.huesped.telefono" class="ra-contact" :href="`tel:${abierta.huesped.tel}`"><span aria-hidden="true" v-html="IC.tel"></span><span>{{ abierta.huesped.telefono }}</span></a>
                            <p v-if="intakeLoading" class="ra-intake-loading">{{ $t('admin_reservas.p.intake_loading') }}</p>
                            <div v-for="it in intakes" :key="it.id" class="ra-intake">
                                <button type="button" class="ra-intake-btn" :aria-expanded="String(intakeAbierto === it.id)" @click="intakeAbierto = intakeAbierto === it.id ? null : it.id">
                                    <b>{{ $t('admin_reservas.p.intake', { id: it.id }) }}</b>
                                    <span v-if="it.ciudad_destino"> · {{ it.ciudad_destino }}</span>
                                    <span v-if="it.presupuesto_usd"> · USD {{ it.presupuesto_usd }}</span>
                                </button>
                                <dl v-if="intakeAbierto === it.id" class="ra-intake-panel">
                                    <template v-for="c in camposIntake(it)"><dt :key="`k-${c.k}`">{{ c.k }}</dt><dd :key="`v-${c.k}`">{{ c.v }}</dd></template>
                                </dl>
                                <a class="ra-link" :href="`/dashboard-intakes?intake=${it.id}`" target="_blank" rel="noopener">{{ $t('admin_reservas.p.intake_open') }} <span aria-hidden="true" v-html="IC.ext"></span></a>
                            </div>
                        </div>
                    </div>
                </div>

                <footer class="ra-d-actions">
                    <button type="button" class="bk-btn ra-btn--ok" :disabled="!abierta.puedeOperar || accionando" @click="confirmar('pay')">
                        <span aria-hidden="true" v-html="IC.pay"></span>{{ $t(abierta.pagada ? 'admin_reservas.a.already_paid' : 'admin_reservas.a.pay') }}
                    </button>
                    <button type="button" class="bk-btn ra-btn--danger" :disabled="!abierta.puedeOperar || accionando" @click="confirmar('cancel')">
                        <span aria-hidden="true" v-html="IC.ban"></span>{{ $t('admin_reservas.a.cancel') }}
                    </button>
                    <button
                        v-if="abierta.conGarantia"
                        type="button"
                        class="bk-btn bk-btn--ghost"
                        :disabled="!isMainAdmin || !!abierta.raw.fecha_garantia_pago || accionando"
                        @click="confirmar('deposit')"
                    >
                        <span aria-hidden="true" v-html="IC.shield"></span>{{ $t(abierta.raw.fecha_garantia_pago ? 'admin_reservas.a.deposit_done' : 'admin_reservas.a.deposit') }}
                    </button>
                    <p class="ra-d-hint">{{ pista }}</p>
                </footer>
            </article>
        </div>

        <!-- ═══ Confirmación ═══ -->
        <div v-if="modal" class="ra-modal">
            <div class="ra-modal-bg" @click="cerrarModal"></div>
            <div ref="modalCard" class="ra-modal-card" role="alertdialog" aria-modal="true" aria-labelledby="ra-m-title" aria-describedby="ra-m-text">
                <div :class="['ra-modal-ico', modal.cls]" aria-hidden="true" v-html="modal.ico"></div>
                <h2 id="ra-m-title">{{ $t(`admin_reservas.c.${modal.act}_t`) }}</h2>
                <p id="ra-m-text">{{ $t(`admin_reservas.c.${modal.act}_p`, { id: modal.id }) }}</p>
                <div class="ra-modal-actions">
                    <button type="button" class="bk-btn bk-btn--ghost" @click="cerrarModal">{{ $t('admin_reservas.c.back') }}</button>
                    <button ref="modalOk" type="button" :class="['bk-btn', modal.act === 'cancel' ? 'ra-btn--danger' : 'bk-btn--primary']" :disabled="accionando" @click="ejecutar">
                        <span v-if="accionando" class="bk-spinner"></span>{{ $t(`admin_reservas.c.${modal.act}_ok`) }}
                    </button>
                </div>
            </div>
        </div>

        <transition name="ra-toast">
            <div v-if="aviso" :class="['ra-toast', { 'is-error': aviso.error }]" role="status" aria-live="polite">{{ aviso.txt }}</div>
        </transition>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import { superAdminEmail } from '@/config';
import apiUrls from '@/new-constants/apiUrls';
import BkPaginacion from '@/components/Cuenta/BkPaginacion.vue';
import HyFLoader from '@/components/Loader/HyFLoader.vue';
import ICON from '@/components/Cuenta/iconos';

// Íconos (texto fijo de este archivo, nunca datos del usuario).
const P = d => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
const IC = {
    back: P('<path d="M15 18l-6-6 6-6"/>'),
    chev: P('<path d="m9 18 6-6-6-6"/>'),
    x: P('<path d="M18 6 6 18M6 6l12 12"/>'),
    ext: P('<path d="M14 4h6v6M20 4l-9 9M19 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5"/>'),
    info: P('<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/>'),
    warn: P('<path d="M12 3 2 20h20z"/><path d="M12 10v4M12 17h.01"/>'),
    ok: P('<circle cx="12" cy="12" r="9"/><path d="m8 12 3 3 5-6"/>'),
    no: P('<circle cx="12" cy="12" r="9"/><path d="m9 9 6 6M15 9l-6 6"/>'),
    pay: P('<rect x="2" y="6" width="20" height="13" rx="2"/><path d="M2 10h20M6 15h4"/>'),
    ban: P('<circle cx="12" cy="12" r="9"/><path d="m5.6 5.6 12.8 12.8"/>'),
    shield: P('<path d="M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6z"/><path d="m9 12 2 2 4-4"/>'),
    search: ICON.search, home: ICON.home, mail: ICON.mail, tel: ICON.tel, copy: ICON.copy,
};

const LOCALES = { es: 'es-CL', en: 'en-US', pt: 'pt-BR', fr: 'fr-FR', it: 'it-IT', de: 'de-DE' };
const POR_PAGINA = 10;
const ESTADOS = ['all', 'initiated', 'accepted', 'canceled', 'rejected'];
// Fecha 'YYYY-MM-DD' (filtro por fecha de reserva, también desde la URL).
const esDia = v => typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v);
// Filtros sin aplicar.
const SIN_FILTROS = () => ({ q: '', estado: 'all', modelo: 'all', pago: 'all', intake: 'all', desde: '', hasta: '' });
// Filtros de lista: clave en `f`, texto de la etiqueta y opciones (claves de admin_reservas.f).
const SELECTS = [
    { k: 'modelo', t: 'model', o: [{ v: 'all', t: 'model_all' }, { v: '4', t: 'model_4' }, { v: 'garantia', t: 'model_g' }] },
    { k: 'pago', t: 'pay', o: [{ v: 'all', t: 'pay_all' }, { v: 'si', t: 'pay_yes' }, { v: 'no', t: 'pay_no' }] },
    { k: 'intake', t: 'intake', o: [{ v: 'all', t: 'intake_all' }, { v: 'si', t: 'intake_yes' }, { v: 'no', t: 'intake_no' }] },
];
const DIAS_NUEVA = 7;

export default {
    name: 'Reservations',
    components: { BkPaginacion, HyFLoader },
    data() {
        const q = this.$route.query;
        return {
            IC,
            ESTADOS,
            SELECTS,
            f: {
                q: typeof q.q === 'string' ? q.q : '',
                estado: ESTADOS.includes(q.estado) ? q.estado : 'all',
                modelo: ['4', 'garantia'].includes(q.modelo) ? q.modelo : 'all',
                pago: ['si', 'no'].includes(q.pago) ? q.pago : 'all',
                intake: ['si', 'no'].includes(q.intake) ? q.intake : 'all',
                desde: esDia(q.desde) ? q.desde : '',
                hasta: esDia(q.hasta) ? q.hasta : '',
            },
            pagina: Number(q.page) > 0 ? Number(q.page) : 1,
            busqueda: typeof q.q === 'string' ? q.q : '',
            cargando: true,
            error: false,
            abiertaId: q.r ? Number(q.r) : null,
            cerrando: false,
            modal: null,
            accionando: false,
            aviso: null,
            intakes: [],
            intakeLoading: false,
            intakeAbierto: null,
            cookiesAlto: 0,
        };
    },
    computed: {
        ...mapState('adminReservation', ['reservations']),
        ...mapState('exchange', ['currencyConversionTable', 'visitorCurrency']),
        // Moneda elegida arriba (header). Null mientras no cargó la tabla: se
        // muestra la moneda original de cada reserva.
        monedaVista() {
            const tabla = this.currencyConversionTable || [];
            const m = this.visitorCurrency;
            return m && tabla.some(x => x.moneda === m) ? m : null;
        },
        loc() { return LOCALES[this.$i18n.locale] || 'es-CL'; },
        isMainAdmin() {
            const user = this.$store.state.user || {};
            const correo = (user.correo || user.email || '').trim().toLowerCase();
            return correo === superAdminEmail.trim().toLowerCase();
        },
        datos() { return this.reservations && Array.isArray(this.reservations.data) ? this.reservations : { data: [] }; },
        filas() { return this.datos.data.map(this.armar); },
        filtrando() {
            const f = this.f;
            return !!f.q || f.estado !== 'all' || f.modelo !== 'all' || f.pago !== 'all' || f.intake !== 'all' || !!f.desde || !!f.hasta;
        },
        // Hoy en hora local (toISOString daría el día en UTC).
        hoy() {
            const d = new Date();
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        },
        // Filtros aplicados (sin el buscador), como chips para quitarlos de a uno.
        activos() {
            const f = this.f, t = k => this.$t(`admin_reservas.f.${k}`), out = [];
            if (f.estado !== 'all') out.push({ k: 'estado', t: `${t('status')}: ${t(f.estado)}` });
            SELECTS.forEach(s => {
                if (f[s.k] === 'all') return;
                const o = s.o.find(x => x.v === f[s.k]);
                out.push({ k: s.k, t: `${t(s.t)}: ${o ? t(o.t) : f[s.k]}` });
            });
            if (f.desde || f.hasta) out.push({ k: 'fecha', t: `${t('date')}: ${f.desde ? this.fechaNum(f.desde) : '…'} – ${f.hasta ? this.fechaNum(f.hasta) : '…'}` });
            return out;
        },
        resumen() {
            const r = this.datos.resumen || {};
            return {
                total: r.total != null ? r.total : (this.datos.total || 0),
                porResponder: r.por_responder || 0,
                sinPagar: r.aceptadas_sin_pagar || 0,
                pagadas: r.pagadas || 0,
            };
        },
        abierta() {
            if (!this.abiertaId) return null;
            return this.filas.find(x => x.id === this.abiertaId) || null;
        },
        reparto() { return this.abierta && this.abierta.d ? this.armarReparto(this.abierta) : null; },
        pista() {
            const a = this.abierta;
            if (!a) return '';
            if (!a.conGarantia) return this.$t('admin_reservas.a.hint_4');
            if (a.raw.fecha_garantia_pago) return this.$t('admin_reservas.a.hint_released', { d: this.fechaNum(a.raw.fecha_garantia_pago) });
            if (!this.isMainAdmin) return this.$t('admin_reservas.a.hint_main');
            return '';
        },
    },
    watch: {
        // Debounce: se espera a que el admin termine de tipear y se vuelve a la
        // página 1. Se limpia el '#' que se copia junto con el id.
        busqueda(v) {
            clearTimeout(this._t);
            this._t = setTimeout(() => {
                const term = String(v || '').trim().replace(/^#+/, '').trim();
                if (term === this.f.q) return;
                this.f.q = term;
                this.pagina = 1;
                this.cargar();
            }, 350);
        },
        abierta(v, antes) {
            if (v && !antes) this.alAbrir();
            if (!v && antes) this.alCerrar();
        },
    },
    created() {
        this._t = null;
        this._req = 0;
        this._avisoT = null;
        this._foco = null;
        this.onKey = this.onKey.bind(this);
        this.cargar();
    },
    beforeDestroy() {
        clearTimeout(this._t);
        clearTimeout(this._avisoT);
        this.alCerrar();
    },
    methods: {
        ...mapActions('adminReservation', ['fetchReservations', 'setReservationAsPaid', 'setReservationAsCanceled', 'paySecurityDeposit']),

        // ── Carga y URL ──────────────────────────────────────────────────
        async cargar() {
            const id = ++this._req;
            this.cargando = true;
            this.error = false;
            this.syncUrl();
            const params = { page: this.pagina, perPage: POR_PAGINA, type: 'received', desglose: true };
            if (this.f.estado !== 'all') params.status = this.f.estado;
            if (this.f.q) params.search = this.f.q;
            if (this.f.modelo !== 'all') params.modelo = this.f.modelo;
            if (this.f.pago !== 'all') params.pago = this.f.pago;
            if (this.f.intake !== 'all') params.intake = this.f.intake;
            if (this.f.desde) params.desde = this.f.desde;
            if (this.f.hasta) params.hasta = this.f.hasta;
            try {
                await this.fetchReservations(params);
                if (id !== this._req) return;
                // La reserva de la URL (?r=) que no está en esta página no se abre.
                if (this.abiertaId && !this.abierta) this.abiertaId = null;
            } catch (e) {
                if (id !== this._req) return;
                console.error('[Reservations] no se pudieron leer las reservas', e);
                this.error = true;
            } finally {
                if (id === this._req) {
                    this.cargando = false;
                    this.syncUrl();
                }
            }
        },
        syncUrl() {
            const q = {};
            if (this.f.q) q.q = this.f.q;
            if (this.f.estado !== 'all') q.estado = this.f.estado;
            if (this.f.modelo !== 'all') q.modelo = this.f.modelo;
            if (this.f.pago !== 'all') q.pago = this.f.pago;
            if (this.f.intake !== 'all') q.intake = this.f.intake;
            if (this.f.desde) q.desde = this.f.desde;
            if (this.f.hasta) q.hasta = this.f.hasta;
            if (this.pagina > 1) q.page = String(this.pagina);
            if (this.abiertaId) q.r = String(this.abiertaId);
            if (JSON.stringify(q) === JSON.stringify(this.$route.query)) return;
            this.$router.replace({ query: q }).catch(() => {});
        },
        cambiar(k, v) {
            // Fecha borrada o inválida = sin ese límite.
            if ((k === 'desde' || k === 'hasta') && !esDia(v)) v = '';
            if (this.f[k] === v) return;
            this.f[k] = v;
            this.pagina = 1;
            this.cargar();
        },
        // Quita un filtro desde su chip.
        quitar(k) {
            if (k === 'fecha') { this.f.desde = ''; this.f.hasta = ''; } else this.f[k] = 'all';
            this.pagina = 1;
            this.cargar();
        },
        limpiar() {
            this.f = SIN_FILTROS();
            this.busqueda = '';
            this.pagina = 1;
            this.cargar();
        },
        irAPagina(p) {
            this.pagina = p;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.cargar();
        },

        // ── Formato ──────────────────────────────────────────────────────
        numero(n) {
            const v = Number(n);
            if (!isFinite(v)) return '—';
            return new Intl.NumberFormat(this.loc, { maximumFractionDigits: 2 }).format(v);
        },
        dinero(n, moneda) {
            if (n === null || n === undefined || n === '') return '—';
            const v = Number(n);
            if (!isFinite(v)) return '—';
            // Monedas sin centavos en la práctica (como el resto del sitio con CLP).
            const dec = ['CLP', 'COP', 'PYG', 'ARS'].includes(moneda) ? 0 : 2;
            // "177,90" y no "177,9"; los enteros quedan sin ",00".
            const abs = Math.round(Math.abs(v) * 100) / 100;
            const min = dec && abs % 1 !== 0 ? 2 : 0;
            const s = new Intl.NumberFormat(this.loc, { minimumFractionDigits: min, maximumFractionDigits: dec }).format(abs);
            return `${v < 0 ? '−' : ''}${moneda ? moneda + ' ' : ''}${s}`;
        },
        // Monto de una reserva pasado a la moneda elegida arriba, con la tabla
        // de cambio del sitio (la misma que usa priceConverter). Null si no hay
        // con qué convertir.
        conv(n, desde) {
            const v = Number(n);
            if (!isFinite(v)) return null;
            const destino = this.monedaVista;
            if (!destino || !desde || desde === destino) return v;
            const tabla = this.currencyConversionTable || [];
            const a = tabla.find(x => x.moneda === desde);
            const b = tabla.find(x => x.moneda === destino);
            const ra = a && parseFloat(a.cambio), rb = b && parseFloat(b.cambio);
            if (!ra || !rb) return null;
            return v * rb / ra;
        },
        // Formatea en la moneda elegida; si no se puede convertir, en la original.
        plata(n, desde) {
            if (n === null || n === undefined || n === '') return '—';
            const c = this.conv(n, desde);
            return c === null ? this.dinero(n, desde) : this.dinero(c, this.monedaVista || desde);
        },
        convierte(desde) {
            return !!(this.monedaVista && desde && desde !== this.monedaVista && this.conv(1, desde) !== null);
        },
        tasaTxt(t) {
            return new Intl.NumberFormat(this.loc, { style: 'percent', maximumFractionDigits: 2 }).format(Number(t) || 0);
        },
        pct(n) { return new Intl.NumberFormat(this.loc, { maximumFractionDigits: 2 }).format(Number(n) || 0); },
        fecha(v, o) {
            const iso = String(v || '').slice(0, 10);
            const d = new Date(iso + 'T12:00:00');
            if (!/^\d{4}-\d{2}-\d{2}$/.test(iso) || isNaN(d)) return '—';
            return new Intl.DateTimeFormat(this.loc, o).format(d).replace(/\./g, '');
        },
        fechaNum(v) { return this.fecha(v, { day: '2-digit', month: '2-digit', year: 'numeric' }); },
        nombreAlojamiento(texto) {
            if (!texto) return '';
            try {
                const j = JSON.parse(texto);
                if (j && typeof j === 'object') return j[this.$i18n.locale] || j.es || j.en || Object.values(j)[0] || '';
                return String(texto);
            } catch (e) {
                return String(texto);
            }
        },
        persona(u, conApellido) {
            const p = u || {};
            const nombre = [p.nombre, conApellido ? p.apellido : null].filter(v => v && v !== 'null').join(' ') || '—';
            return {
                id: p.idusuario || null,
                nombre,
                ini: nombre === '—' ? '?' : nombre.split(/\s+/).map(x => x.charAt(0)).join('').slice(0, 2).toUpperCase(),
                correo: p.correo || '',
                telefono: p.telefono || '',
                tel: String(p.telefono || '').replace(/[^\d+]/g, ''),
            };
        },

        // ── Una fila ─────────────────────────────────────────────────────
        estado(r) {
            if (r.status === 'canceled') return { k: 'bad', badge: 'bad', t: 'canceled' };
            if (r.status === 'rejected') return { k: 'off', badge: 'plain', t: 'rejected' };
            if (r.fecha_pago) return { k: 'ok', badge: 'ok', t: 'paid' };
            if (r.status === 'accepted') return { k: 'pay', badge: 'pay', t: 'accepted' };
            if (r.status === 'pending') return { k: 'wait', badge: 'wait', t: 'pending' };
            return { k: 'wait', badge: 'wait', t: 'initiated' };
        },
        armar(r) {
            const acc = r.accommodation || {};
            const d = r.desglose || null;
            const desde = String(r.fecha_inicio || '').slice(0, 10);
            const hasta = String(r.fecha_termino || '').slice(0, 10);
            const noches = d ? d.dias : (Math.max(0, Math.round((new Date(hasta + 'T12:00:00') - new Date(desde + 'T12:00:00')) / 864e5)) || 0);
            const creada = String(r.fecha_reserva || '').slice(0, 10);
            const edad = creada ? (Date.now() - new Date(creada + 'T12:00:00')) / 864e5 : Infinity;
            const fin = r.status === 'canceled' || r.status === 'rejected';
            const pagada = !!r.fecha_pago;
            const pasos = fin
                ? [{ k: 'requested', st: 'done' }, { k: r.status, st: 'end' }]
                : [
                    { k: 'requested', st: 'done' },
                    { k: 'accepted', st: r.status === 'accepted' || pagada ? 'done' : 'now' },
                    { k: 'paid', st: pagada ? 'done' : (r.status === 'accepted' ? 'now' : '') },
                ];
            const modos = { mensual: 'mode_mensual', diario: 'mode_diario', ambos: 'mode_ambos' };
            const garantiaGuardada = Number(r.garantia) > 0 || (d && d.garantia > 0);
            return {
                raw: r,
                id: r.idreserva,
                e: this.estado(r),
                d,
                moneda: r.moneda || (d && d.moneda) || '',
                pagada,
                nueva: edad >= 0 && edad < DIAS_NUEVA,
                creadaCorta: this.fecha(creada, { day: 'numeric', month: 'short' }),
                creadaNum: this.fechaNum(creada),
                pagoNum: this.fechaNum(r.fecha_pago),
                fechas: `${this.fecha(desde, { day: 'numeric', month: 'short' })} → ${this.fecha(hasta, { day: 'numeric', month: 'short', year: 'numeric' })}`,
                ent: { dia: this.fecha(desde, { day: 'numeric' }), mes: this.fecha(desde, { month: 'short', year: 'numeric' }) },
                sal: { dia: this.fecha(hasta, { day: 'numeric' }), mes: this.fecha(hasta, { month: 'short', year: 'numeric' }) },
                noches,
                alojamientoId: r.alojamiento_idalojamiento || acc.idalojamiento,
                alojamiento: this.nombreAlojamiento(acc.nombre),
                direccion: acc.direccion || '',
                fichaUrl: this.$router.resolve({ name: 'detalle-alojamiento', params: { idalojamiento: r.alojamiento_idalojamiento || acc.idalojamiento } }).href,
                arriendo: acc.arriendo != null ? `${this.plata(acc.arriendo, acc.moneda || r.moneda)}${acc.modalidad_tiempo === 'diario' ? '' : ' ' + this.$t('admin_reservas.d.per_month')}` : '—',
                convertida: this.convierte(r.moneda || (d && d.moneda)),
                modalidad: modos[acc.modalidad_tiempo] ? this.$t(`admin_reservas.d.${modos[acc.modalidad_tiempo]}`) : '—',
                huespedes: r.huespedes || '—',
                cupon: r.cupon || null,
                huesped: this.persona(r.user, true),
                anfitrion: this.persona(acc.user, true),
                pasos,
                // Mismas reglas que el panel anterior: se puede marcar pagada o
                // cancelar mientras no esté pagada ni cancelada.
                puedeOperar: !pagada && r.status !== 'canceled',
                // Liberar garantía solo tiene sentido si H&F la cobró.
                conGarantia: !!(garantiaGuardada || (d && d.modelo.cobra_garantia) || r.fecha_garantia_pago),
            };
        },

        // ── Reparto del cobro (todo viene calculado de la API) ───────────
        armarReparto(a) {
            const d = a.d, c = a.moneda, t = k => this.$t(`admin_reservas.split.${k}`);
            const tc = (k, n) => this.$tc(`admin_reservas.split.${k}`, n, { n });
            const $ = n => this.plata(n, c);
            const r = a.raw, pagada = a.pagada, p = d.pago || {};
            const es4 = !!d.modelo.es_comision;
            const tasa = this.tasaTxt(d.tasa_anfitrion);
            const L = (label, val, cls, sub) => ({ label, val, cls: cls || '', sub: sub || '' });

            let estado;
            if (r.status === 'canceled' || r.status === 'rejected') estado = t('state_not_charged');
            else if (pagada) estado = this.$t('admin_reservas.split.state_paid', { d: this.fechaNum(r.fecha_pago) });
            else if (r.status === 'accepted') estado = t('state_to_charge');
            else estado = t('state_estimate');

            const gwNombre = p.medio ? this.$t(`admin_reservas.gw.${p.medio === 'manual' && p.por_transferencia ? 'transfer' : p.medio}`) : '';

            // Paga el huésped
            const g = [];
            if (d.estadia_cobrada) {
                g.push(d.dias < 30
                    ? L(t('stay_full'), $(d.estadia_cobrada), '', t('stay_full_sub'))
                    : L(t('first_month'), $(d.estadia_cobrada), '', tc('first_month_sub', d.meses)));
            }
            if (d.garantia) g.push(L(tc('guarantee', d.modelo.garantia_meses || 1), $(d.garantia), '', t('guarantee_sub')));
            const cargoSub = d.cargo_con_tope ? t('charge_cap') : t(`charge_${d.cargo_pct}`);
            g.push(L(this.$t('admin_reservas.split.charge', { p: d.cargo_pct }), $(d.cargo_sin_cupon || d.cargo), '', cargoSub));
            if (d.cupon_descuento && a.cupon) g.push(L(this.$t('admin_reservas.split.coupon', { code: a.cupon.code, p: a.cupon.percentage }), '−' + $(d.cupon_descuento), 'is-plus'));
            if (pagada && p.recargo) g.push(L(this.$t('admin_reservas.split.surcharge', { g: gwNombre, p: this.pct(p.recargo_pct) }), $(p.recargo), 'is-muted'));
            if (pagada) g.push(L(t('total_paid'), $(d.total + (p.recargo || 0)), 'is-total'));
            else {
                g.push(L(t('surcharge_later'), t('surcharge_later_val'), 'is-muted', t('surcharge_later_sub')));
                g.push(L(t('total_to'), $(d.total), 'is-total', t('total_to_sub')));
            }

            // Recibe el anfitrión
            const h = [];
            if (es4) {
                h.push(L(t(d.dias < 30 ? 'h_stay_full' : 'h_first'), $(d.estadia_cobrada)));
                h.push(L(this.$t('admin_reservas.split.h_fee', { p: tasa }), '−' + $(d.comision_anfitrion), 'is-minus is-hf', this.$t('admin_reservas.split.h_fee_sub', { p: tasa, m: $(d.estadia_total) })));
                h.push(L(t('h_transfer'), $(d.transferencia), 'is-total'));
                if (d.resto_directo) h.push(L(t('h_direct'), $(d.resto_directo), 'is-muted', t('h_direct_sub')));
                h.push(L(t('h_total'), $(d.total_anfitrion), '', t('h_total_sub')));
            } else {
                h.push(L(t('g_rent'), $(d.estadia_total), '', d.estadia_cobrada ? t('g_rent_by_hf') : t('g_rent_direct')));
                h.push(L(t('g_fee'), $(0), 'is-muted', t('g_fee_sub')));
                if (d.garantia) {
                    h.push(L(t('g_guarantee'), $(d.garantia), r.fecha_garantia_pago ? 'is-plus' : '',
                        r.fecha_garantia_pago ? this.$t('admin_reservas.split.g_released', { d: this.fechaNum(r.fecha_garantia_pago) }) : t('g_held')));
                }
                h.push(L(t('h_total'), $(d.total_anfitrion), 'is-total'));
            }

            // Queda para H&F
            const f = [L(t('f_charge'), $(d.cargo), '', d.cupon_descuento ? t('f_charge_coupon') : '')];
            if (es4) f.push(L(this.$t('admin_reservas.split.f_fee', { p: tasa }), $(d.comision_anfitrion)));
            f.push(L(t('f_total'), $(d.ingreso_hf), 'is-total', t('f_total_sub')));

            // Barra: estadía total + cargo
            const base = (d.estadia_total + d.cargo) || 1;
            const bar = { host: d.total_anfitrion / base * 100, fee: d.comision_anfitrion / base * 100, cargo: d.cargo / base * 100 };

            // Control de lo cobrado
            let control = null;
            if (pagada && p.valor_pagado != null && p.medio && p.medio !== 'otro') {
                // Lo cobrado en otra moneda (MP en CLP, PayPal en USD) se muestra tal cual.
                const m = p.comparable ? $(p.valor_pagado) : this.dinero(p.valor_pagado, p.moneda_pagada);
                if (!p.comparable) control = { k: 'warn', txt: this.$t('admin_reservas.split.control_other', { g: gwNombre, m }) };
                else if (p.coincide) control = { k: 'ok', txt: this.$t('admin_reservas.split.control_ok', { g: gwNombre, m }) };
                else control = { k: 'warn', txt: this.$t('admin_reservas.split.control_dif', { g: gwNombre, m, d: $(p.diferencia), e: $(p.esperado) }) };
            }

            // Montos convertidos a la moneda del header: se avisa y se deja el original.
            const convNota = a.convertida
                ? this.$t('admin_reservas.d.converted', { to: this.monedaVista, from: c, orig: this.dinero(d.total + (pagada ? (p.recargo || 0) : 0), c) })
                : '';

            return {
                es4, tasa, estado, convNota,
                origen: d.modelo.origen,
                modeloNombre: d.modelo.nombre,
                bar,
                barPct: { a: Math.round(bar.host), b: Math.round(bar.fee), c: Math.round(bar.cargo) },
                leyenda: { host: $(d.total_anfitrion), fee: $(d.comision_anfitrion), cargo: $(d.cargo) },
                cajas: [
                    { k: 'guest', ico: 'H', titulo: t('guest_box'), sub: a.huesped.nombre, lineas: g },
                    { k: 'host', ico: 'A', titulo: t('host_box'), sub: a.anfitrion.nombre, lineas: h },
                    { k: 'hf', ico: 'H&F', titulo: t('hf_box'), sub: t(es4 ? 'hf_sub_4' : 'hf_sub_g'), lineas: f },
                ],
                control,
            };
        },

        // ── Panel de detalle ─────────────────────────────────────────────
        abrir(id, desde) {
            this._foco = desde || document.activeElement;
            this.cerrando = false;
            this.abiertaId = id;
            this.syncUrl();
        },
        alAbrir() {
            document.documentElement.classList.add('ra-locked');
            document.addEventListener('keydown', this.onKey);
            // El aviso de cookies del sitio (fijo abajo, z-index máximo) taparía
            // los botones del panel: el panel termina encima de él.
            this.medirCookies();
            this._cookiesT = setInterval(this.medirCookies, 800);
            this.$nextTick(() => {
                if (this.$refs.card) { this.$refs.card.scrollTop = 0; this.$refs.card.focus(); }
            });
            this.cargarIntakes(this.abierta);
        },
        alCerrar() {
            clearInterval(this._cookiesT);
            document.documentElement.classList.remove('ra-locked');
            document.removeEventListener('keydown', this.onKey);
            this.intakes = [];
            this.intakeAbierto = null;
        },
        medirCookies() {
            const c = document.querySelector('.cookie-footer');
            // (offsetParent no sirve: con position: fixed siempre es null)
            const alto = c ? c.getBoundingClientRect().height : 0;
            const visible = alto > 0 && c.getBoundingClientRect().top < window.innerHeight && getComputedStyle(c).display !== 'none' && getComputedStyle(c).visibility !== 'hidden';
            this.cookiesAlto = visible ? Math.round(alto) : 0;
        },
        cerrar() {
            if (!this.abierta || this.cerrando) return;
            this.cerrando = true;
            setTimeout(() => {
                this.cerrando = false;
                this.abiertaId = null;
                this.syncUrl();
                const el = this._foco;
                this._foco = null;
                if (el && document.contains(el)) el.focus();
            }, 200);
        },
        onKey(e) {
            if (e.key === 'Escape') {
                if (this.modal) return this.cerrarModal();
                return this.cerrar();
            }
            if (e.key !== 'Tab') return;
            const cont = this.modal ? this.$refs.modalCard : this.$refs.card;
            if (!cont) return;
            const els = Array.from(cont.querySelectorAll('button:not(:disabled), a[href], select, input')).filter(x => x.offsetParent !== null);
            if (!els.length) return;
            const first = els[0], last = els[els.length - 1];
            if (e.shiftKey && (document.activeElement === first || document.activeElement === cont)) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        },
        async copiar(id) {
            try {
                await navigator.clipboard.writeText(String(id));
                this.avisar(this.$t('admin_reservas.d.copied', { id }));
            } catch (e) {
                this.avisar(this.$t('admin_reservas.d.copy_id', { id }));
            }
        },
        irBackoffice(hostId) {
            this.$router.push({ name: 'admin-backoffice', query: { host: String(hostId) } });
        },

        // Intake enlazado por teléfono del huésped (igual que antes).
        async cargarIntakes(a) {
            this.intakes = [];
            this.intakeAbierto = null;
            const guest = a && a.raw.user;
            const digits = guest && guest.telefono ? String(guest.telefono).replace(/\D/g, '') : '';
            if (digits.length < 6) return;
            const id = a.id;
            this.intakeLoading = true;
            try {
                let url = apiUrls.dashboardIntakeByPhone(digits);
                if (guest.correo) url += `?email=${encodeURIComponent(guest.correo)}`;
                const res = await axios.get(url);
                if (this.abiertaId === id) this.intakes = res.data && Array.isArray(res.data.data) ? res.data.data : [];
            } catch (e) {
                console.warn('[Reservations] no se pudieron cargar intakes por teléfono:', e && e.message ? e.message : e);
            } finally {
                this.intakeLoading = false;
            }
        },
        camposIntake(it) {
            const out = [];
            const add = (k, v) => { if (v) out.push({ k, v }); };
            add(this.$t('admin_reservas.p.city'), it.ciudad_destino);
            add(this.$t('admin_reservas.p.budget'), it.presupuesto_usd ? `USD ${it.presupuesto_usd}` : '');
            add('Email', it.email);
            add('WhatsApp', it.whatsapp);
            add(this.$t('admin_reservas.d.check_in'), it.fecha_inicio ? this.fechaNum(it.fecha_inicio) : '');
            add(this.$t('admin_reservas.d.check_out'), it.fecha_fin ? this.fechaNum(it.fecha_fin) : '');
            add(this.$t('admin_reservas.p.state'), it.estado);
            return out;
        },

        // ── Acciones ─────────────────────────────────────────────────────
        confirmar(act) {
            if (!this.abierta) return;
            const ico = { pay: IC.pay, cancel: IC.ban, deposit: IC.shield }[act];
            const cls = { pay: 'is-ok', cancel: 'is-bad', deposit: '' }[act];
            this._focoModal = document.activeElement;
            this.modal = { act, id: this.abierta.id, ico, cls };
            this.$nextTick(() => this.$refs.modalOk && this.$refs.modalOk.focus());
        },
        cerrarModal() {
            if (this.accionando) return;
            this.modal = null;
            const el = this._focoModal;
            this._focoModal = null;
            this.$nextTick(() => { if (el && document.contains(el)) el.focus(); else if (this.$refs.card) this.$refs.card.focus(); });
        },
        async ejecutar() {
            const m = this.modal;
            const a = this.abierta;
            if (!m || !a || this.accionando) return;
            this.accionando = true;
            let ok = false;
            try {
                // Las acciones del store devuelven los datos o undefined si falló.
                const res = m.act === 'pay' ? await this.setReservationAsPaid(a.raw)
                    : m.act === 'cancel' ? await this.setReservationAsCanceled(a.raw)
                        : await this.paySecurityDeposit(a.raw);
                ok = res !== undefined && !(res && res.status === 'Failed');
            } catch (e) {
                ok = false;
            }
            this.accionando = false;
            this.modal = null;
            await this.cargar();
            this.$nextTick(() => this.$refs.card && this.$refs.card.focus());
            const msg = { pay: 'paid', cancel: 'canceled', deposit: 'released' }[m.act];
            this.avisar(ok ? this.$t(`admin_reservas.toast.${msg}`, { id: m.id }) : this.$t('admin_reservas.toast.error'), !ok);
        },
        avisar(txt, error) {
            clearTimeout(this._avisoT);
            this.aviso = { txt, error: !!error };
            this._avisoT = setTimeout(() => { this.aviso = null; }, 3500);
        },
    },
};
</script>

<style src="../../BankInformation/bkCuenta.css"></style>
<style src="../../Cuenta/cuentaMenu.css"></style>
<style src="./reservasAdmin.css"></style>
